import React, { useCallback, useEffect, useState } from 'react'
import { Button } from '@nvidia/kaizen-ui'
import { Radio } from '@nvidia/kaizen-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faEnvelope, faSpinner } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import { GET_ACTIVATIONTOKEN } from '../constants/apiMethods'
import TransferEnablementModal from './TransferEnablementModal'
import './ClaimEnablement.css'
import * as ApiMethods from "../constants/apiMethods";



const ViewAccountType = {
  ELIGIBLE: 'eligible',
  ALL: 'all',
  NOTELIGIBLE:'notEligible'
}

export default function ClaimEnablement({ productActivationId, user, accountsData: initialAccountsData, onComplete, ngc_ProductFam }) {
  console.log('ClaimEnablement rendered with props:', { productActivationId, user, initialAccountsData, onComplete, ngc_ProductFam });
  
  const [viewType, setViewType] = useState('eligible')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isTransferData, setIsTransferData] = useState(null)
  const [isTransferred, setIsTransferred] = useState(false)
  const [selectedAccountId, setSelectedAccountId] = useState(null)
  
  const [validationError, setValidationError] = useState(null)
  const [accountsData, setAccountsData] = useState(initialAccountsData || null)
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const userEmail = user && user.email ? user.email : (localStorage.getItem("email") || '')
  const nonce = typeof window !== 'undefined' ? crypto.randomUUID() : ''
  
  console.log('ClaimEnablement state:', { viewType, loading, accountsData, selectedAccountId, validationError, success });

  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem('nonce', nonce)
  }

  useEffect(() => {
    console.log('ClaimEnablement useEffect triggered');
    // API call to get accounts data
    const fetchAccountsData = async () => {
      try {
        console.log('=== Starting fetchAccountsData function ===');
        console.log('Fetching accounts data for productActivationId:', productActivationId, 'ngc_ProductFam:', user.ngc_ProductFam);
        console.log('User object:', user);
        setLoading(true)
        
        // Replace with actual API call
        //const response = await axios.get(`${ApiMethods.GET_NGCAccounts}?productActivationId=${productActivationId}`, {
        const queryParams = new URLSearchParams();
        // if (productActivationId) {
        //   queryParams.append('productActivationId', productActivationId);
        // }
        if (user.ngc_ProductFam) {
          queryParams.append('ngc_ProductFam', user.ngc_ProductFam);
        }
        const queryString = queryParams.toString();
        const apiUrl = queryString ? `${ApiMethods.GET_NGCAccounts}?${queryString}` : `${ApiMethods.GET_NGCAccounts}`;
        console.log('API URL:', apiUrl);
        
        const response = await axios.get(apiUrl, {
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'X-User-Sub': user.sub,
            'Content-Type': 'application/json'
          }
        })
        console.log('API response:', response.data);
        setAccountsData(response.data)
        setLoading(false)
      } catch (error) {
        console.error('Failed to fetch accounts data:', error)
        setLoading(false)
      }
    }

    if (productActivationId && !initialAccountsData) {
      console.log('Calling fetchAccountsData');
      fetchAccountsData()
    } else if (initialAccountsData) {
      console.log('Using initial accounts data');
      setAccountsData(initialAccountsData)
      setLoading(false)
    }
  }, [productActivationId, initialAccountsData, user.token, user.sub, ngc_ProductFam])

  const groupedAccounts = {
    eligible: accountsData && accountsData.accounts ? accountsData.accounts.filter((account) => account.eligible) : [],
    all: accountsData && accountsData.accounts ? accountsData.accounts : [],
    notEligible: accountsData && accountsData.accounts
  ? accountsData.accounts.filter((account) => !account.eligible)
  : [],
  }
  console.log("viewType:", viewType);
  console.log("groupedAccounts[viewType]:", groupedAccounts[viewType]);
  console.log("searchTerm:", searchTerm);
  const filteredAccounts = (groupedAccounts[viewType] || []).filter(account =>    

    (account.accountDisplayName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (account.orgDisplayName || '').toLowerCase().includes(searchTerm.toLowerCase())
  )

  const validateSelection = useCallback(
    (accountId) => {
      if (!accountId) {
        setValidationError('Please select an account.')
        return false
      }

      const selectedAccount = accountsData && accountsData.accounts ? accountsData.accounts.find((account) => account.accountId === accountId) : null
      if (!selectedAccount || !selectedAccount.eligible) {
        setValidationError('The selected account is not eligible for activation.')
        return false
      }

      setValidationError(null)
      return true
    },
    [accountsData, setValidationError],
  )

  //const productValues = accountsData && accountsData.products.map((product) => product.displayName).join(', ')

  const createAccount = () => {
    console.log('createAccount called with selectedAccountId:', selectedAccountId);
    
    if (!validateSelection(selectedAccountId)) {
      console.log('Validation failed');
      return // Stop if validation fails
    }
    const selectedAccount = accountsData && accountsData.accounts ? accountsData.accounts.find((account) => account.accountId === selectedAccountId) : null
    
    const orgName = selectedAccount? selectedAccount.orgName : '';
    const accountNumber=selectedAccount? selectedAccount.accountNumber : '';
    const accountName=selectedAccount? selectedAccount.accountName : '';
    console.log('Validation passed, proceeding with account creation');
    const body = {
      accountId: selectedAccountId,
      productActivationId,
      orgName,
      accountNumber,
      accountName
    }
    console.log('Request body:', body);
    // Replace with actual API call
    // activateNcaAccount({ body })
    setSuccess(true)
    setTimeout(() => {
      setSuccess(false)
      if (onComplete) {
        console.log('Calling onComplete callback');
        onComplete(body)
      }
    }, 5000)
  }


  const handleClickNCA = () => {
    console.log('handleClickNCA called with userEmail:', userEmail);
    console.log('handleClickNCA called with user:', user);
    console.log('handleClickNCA called with nonce:', nonce);
    
    localStorage.setItem("returnUrl", window.location.href);
    localStorage.setItem("NewAccountCreated", false);
    
    const callbackUrl = process.env.REACT_APP_BASE_NCA_Redirect_URI;
    const authurl = process.env.REACT_APP_BASE_NCA_CREATE_URL;
    
    console.log('Environment variables:', {
      callbackUrl,
      authurl,
      userEmail: userEmail || ''
    });
    
    // Check if required environment variables are available
    if (!authurl) {
      console.error('REACT_APP_BASE_NCA_CREATE_URL is not defined');
      alert('Configuration error: REACT_APP_BASE_NCA_CREATE_URL is not defined');
      return;
    }
    
    if (!callbackUrl) {
      console.error('REACT_APP_BASE_NCA_Redirect_URI is not defined');
      alert('Configuration error: REACT_APP_BASE_NCA_Redirect_URI is not defined');
      return;
    }
    
    const qParams = new URLSearchParams({
      //redirect_uri: process.env.REACT_APP_BASE_NCA_Redirect_URI,
      callbackUrl: callbackUrl || '',
          
    //  nonce: window.crypto.getRandomValues(new Uint8Array(32)),     
    nonce: nonce || '',     
      
      simplify:true,
      login_hint: userEmail || '',
    });
    try {
    
      const url = `${authurl}?${qParams}`;
      console.log('Generated URL:', url);
     
      
      window.location.assign(url);
      
    } catch (e) {
      console.error('Error in handleClickNCA:', e);
      localStorage.setItem("IsUserLoggedIn", "false");
    }
    
  };
   const formatStartCaseSpacedString = (value) => {
    if (!value) return '-';
  
    if (value === 'NVIDIA_AI_ENTERPRISE_VIEWER') {
      const words = value.split('_');
      return words
        .map((word, index) =>
          index <= 1
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');
    }
    if (value.toLowerCase() === 'nv-ai-enterprise') {
      return 'NVIDIA AI Enterprise'
    }
 
    // generic: lowercase, split into words, capitalize each
    return value
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const noClaimFlow = (!accountsData || !accountsData.accounts || accountsData.accounts.length === 0) && !isTransferred
  const includedSubscriptions = [...new Set(
    (accountsData && accountsData.products) ? accountsData.products.reduce((subscriptions, product) => {
      return subscriptions.concat(product.subscriptions)
    }, []) : []
  )]

  if (loading) {
    return (
      <div>
        {/* Success Toast */}
        {success && (
          <div
            role="status"
            aria-live="polite"
            style={{
              position: 'fixed',
              top: '100px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 1000,
              backgroundColor: '#4caf50',
              color: '#fff',
              padding: '16px 20px',
              borderRadius: '6px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            The product has been successfully activated.
          </div>
        )}
    
        {/* Loading (noClaimFlow) */}
        {noClaimFlow && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 200,
              padding: 20,
            }}
          >
            <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: 24, color: '#76b900' }} />
          </div>
        )}
      </div>
    )
  }

  return (
    <div>
      {/* Main Content */}
      {!noClaimFlow && (
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
            {/* Header / Logo */}
            {/* <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: 20,
                backgroundColor: '#f5f5f5',
                borderBottom: '1px solid #eaeaea',
              }}
            >
              <img src="/images/logo.png" alt="NVIDIA Logo" style={{ height: 40 }} />
            </div> */}
    
            {/* Body */}
            <div style={{ padding: 20, maxWidth: 1200, width: '100%', margin: '0 auto' }}>
              <h1 style={{ margin: '8px 0 16px 0', fontSize: 22 }}>Select NVIDIA Cloud Account (NCA)</h1>
    
              {isTransferred && (
                <div
                  style={{
                    padding: 16,
                    backgroundColor: '#e8f5e9',
                    border: '1px solid #c8e6c9',
                    borderRadius: 6,
                    color: '#2e7d32',
                    marginBottom: 16,
                  }}
                >
                  Product Transfer Success
                </div>
              )}
    
              {!isTransferred && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                  {/* Step Card */}
                  {/* <div
                    style={{
                      padding: 20,
                      backgroundColor: '#fff',
                      border: '1px solid #e0e0e0',
                      borderRadius: 6,
                    }}
                  >
                    <div style={{ marginBottom: 8 }}>
                      <h3 style={{ fontWeight: 600, fontSize: 18, margin: 0 }}>Step 2 of 2: Activate Product</h3>
                    </div>
                    <p style={{ fontWeight: 400, fontSize: 14, margin: 0, lineHeight: 1.5 }}>
                      After login to accept the invitation, an activation for the new product enablement is required.
                    </p>
                  </div> */}
    
                  {/* Product Details Card */}
                  <div
                    style={{
                      padding: 20,
                      backgroundColor: '#fff',
                      border: '1px solid #e0e0e0',
                      borderRadius: 6,
                    }}
                  >
                    <div style={{ marginBottom: 16 }}>
                      <h3 style={{ fontWeight: 600, fontSize: 18, margin: '0 0 10px 0' }}>NGC Product Details</h3>
                      <div
                        style={{
                          minHeight: 30,
                          width: '100%',
                          border: '2px solid #e0e0e0',
                          background: '#f9f9f9',
                          color: '#444',
                          lineHeight: '30px',
                          padding: 1,
                          borderRadius: 6,
                          wordBreak: 'break-word',
                        }}
                      >
                        {accountsData && Array.isArray(accountsData.products) && accountsData.products.length > 0
                          ? accountsData.products.map(p => p && p.displayName).filter(Boolean).join(', ')
                          : '—'}
                      </div>
    
                      <h4 style={{ fontWeight: 600, fontSize: 16, margin: '16px 0 8px 0' }}>
                        Included Subscriptions
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'row', gap: 8, flexWrap: 'wrap' }}>
                        {Array.isArray(includedSubscriptions) && includedSubscriptions.length > 0 ? (
                          includedSubscriptions.map((sub, subIndex) => (
                            <span
                              key={`${sub}-${subIndex}`}
                              style={{
                                backgroundColor: '#76b900',
                                color: '#fff',
                                padding: '4px 12px',
                                borderRadius: 12,
                                fontSize: 12,
                                fontWeight: 600,
                              }}
                            >
                              {formatStartCaseSpacedString(sub)}
                            </span>
                          ))
                        ) : (
                          <span style={{ color: '#777', fontSize: 13 }}>No subscriptions</span>
                        )}
                      </div>
                    </div>
                  </div>
    
                  {/* NCA Card */}
                  <div
                    style={{
                      padding: 20,
                      backgroundColor: '#fff',
                      border: '1px solid #e0e0e0',
                      borderRadius: 6,
                    }}
                  >
                    <div style={{ marginBottom: 16 }}>
                      <h3 style={{ fontWeight: 600, fontSize: 18, margin: '0 0 10px 0' }}>
                        NVIDIA Cloud Account (NCA)
                      </h3>
                      <p style={{ fontWeight: 400, fontSize: 14, margin: '0 0 16px 0', lineHeight: 1.5 }}>
                      "View Eligible NVIDIA Cloud Accounts" displays all the accounts where you are the owner. Choose an eligible account( linked to NGC Org ) from this list to activate the product in the account or Click {' '}"Create new NCA" for a new account.  
                      {' '}"View Other NVIDIA Cloud Accounts” displays all the accounts where you are a member; you will need to reach out to your account owner to activate the product in these accounts.


                      </p>
    
                      {/* View Toggles */}
                      <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: 10,
                            border: '1px solid #e0e0e0',
                            borderRadius: 6,
                            gap: 8,
                          }}
                        >
                          <Radio
                            checked={viewType === ViewAccountType.ELIGIBLE}
                            name="viewAccounts"
                            value="eligible"
                            onChange={() => setViewType(ViewAccountType.ELIGIBLE)}
                          />
                          <label style={{ fontSize: 14, cursor: 'pointer' }}>View Eligible NVIDIA Cloud Accounts</label>
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            style={{ height: 16, width: 16, color: '#666' }}
                            title="The accounts your user ID owns display the corresponding NGC org and any currently activated software products. You can choose any of these accounts to activate your new product."
                          />
                        </div>
    
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: 10,
                            border: '1px solid #e0e0e0',
                            borderRadius: 6,
                            gap: 8,
                          }}
                        >
                          <Radio
                            checked={viewType === ViewAccountType.NOTELIGIBLE}
                            name="viewAccounts"
                            value="all"
                            onChange={() => setViewType(ViewAccountType.NOTELIGIBLE)}
                          />
                          <label style={{ fontSize: 14, cursor: 'pointer' }}>View Other NVIDIA Cloud Accounts</label>
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            style={{ height: 16, width: 16, color: '#666' }}
                            title="The list includes accounts you don’t own but a member of. To activate the product please contact the account owner."
                          />
                        </div>
                      </div>
    
                      {/* Accounts Table */}
                      {accountsData ? (
                        <div>
                          <input
                            type="text"
                            placeholder="Search accounts by name or organization"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                              width: '100%',
                              padding: 12,
                              border: '1px solid #e0e0e0',
                              borderRadius: 6,
                              marginBottom: 16,
                              fontSize: 14,
                            }}
                          />
    
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
                                <th style={{ width: 50, textAlign: 'left', padding: 12 }} />
                                <th style={{ textAlign: 'left', padding: 12, fontSize: 14 }}>Account Name</th>
                                <th style={{ textAlign: 'left', padding: 12, fontSize: 14 }}>Org Name</th>
                                <th style={{ width: 100, textAlign: 'left', padding: 12 }} />
                                <th style={{ textAlign: 'left', padding: 12, fontSize: 14 }}>Subscriptions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(filteredAccounts) && filteredAccounts.length > 0 ? (
                                filteredAccounts.map((account) => (
                                  <tr key={account.accountId} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                    <td style={{ padding: 12 }}>
                                      <Radio
                                        checked={selectedAccountId === account.accountId}
                                        disabled={!account.eligible}
                                        name="selectedAccount"
                                        value={account.accountId}
                                        onChange={() => {
                                          setSelectedAccountId(account.accountId);
                                          validateSelection(account.accountId);
                                        }}
                                      />
                                    </td>
                                    <td style={{ padding: 12 }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        {!account.eligible && (
                                          <FontAwesomeIcon
                                            icon={faInfoCircle}
                                            style={{ color: '#666', height: 15, width: 15 }}
                                            title={account.ineligibilityReason || 'This account is not eligible.'}
                                          />
                                        )}
                                        <span style={{ fontSize: 14 }}>
                                          {account.accountDisplayName || '—'}
                                        </span>
                                      </div>
                                    </td>
                                    <td style={{ padding: 12, fontSize: 14 }}>
                                      {account.orgDisplayName || '—'}
                                    </td>
                                    <td style={{ padding: 12 }}>
                                      {account.isOwner && account.eligible && (
                                        <span
                                          style={{
                                            backgroundColor: '#76b900',
                                            color: '#fff',
                                            padding: '4px 8px',
                                            borderRadius: 12,
                                            fontSize: 12,
                                            fontWeight: 600,
                                            textTransform: 'capitalize',
                                          }}
                                        >
                                          Owner
                                        </span>
                                      )}
                                    </td>
                                    <td style={{ padding: 12 }}>
                                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                        
                                        {Array.isArray(account.subscriptions) && account.subscriptions.length > 0 ? (
                                          account.subscriptions.map((sub, subIndex) => (
                                            <span
                                              key={`${account.accountId}-sub-${subIndex}`}
                                              style={{
                                                backgroundColor: '#76b900',
                                                color: '#fff',
                                                padding: '4px 8px',
                                                borderRadius: 12,
                                                fontSize: 12,
                                                fontWeight: 600,
                                              }}
                                            >
                                              {formatStartCaseSpacedString(sub)}
                                            </span>
                                          ))
                                        ) : (
                                          <span style={{ color: '#777', fontSize: 13 }}>—</span>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} style={{ padding: 16, color: '#777', fontSize: 14, textAlign: 'center' }}>
                                    No accounts found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div style={{ color: '#777', fontSize: 14 }}>No account data available.</div>
                      )}
    
                      {/* Actions */}
                      <div
                        style={{
                          padding: 20,
                          backgroundColor: '#fff',
                          border: '1px solid #e0e0e0',
                          borderRadius: 6,
                          marginTop: 16,
                        }}
                      >
                        {validationError && (
                          <p style={{ color: '#d32f2f', fontSize: 14, margin: '0 0 16px 0' }}>{validationError}</p>
                        )}
  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
  <div>
    <Button onClick={() => handleClickNCA()} style={{ padding: '12px 24px', fontSize: 16 }}
    
    className="custom-new-button"
    >
      Create new NCA
    </Button>
  </div>

  <div style={{ marginLeft: 'auto' ,marginRight:'200px'}}>
    <Button
      onClick={() => createAccount()}
      className="custom-activate-button"
    >
      Continue
    </Button>
  </div>
</div>


                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}




{noClaimFlow && (
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
            {/* Header / Logo */}
            {/* <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: 20,
                backgroundColor: '#f5f5f5',
                borderBottom: '1px solid #eaeaea',
              }}
            >
              <img src="/images/logo.png" alt="NVIDIA Logo" style={{ height: 40 }} />
            </div> */}
    
            {/* Body */}
            <div style={{ padding: 20, maxWidth: 1200, width: '100%', margin: '0 auto' }}>
              <h1 style={{ margin: '8px 0 16px 0', fontSize: 22 }}>Select NVIDIA Cloud Account (NCA)</h1>
    
              {isTransferred && (
                <div
                  style={{
                    padding: 16,
                    backgroundColor: '#e8f5e9',
                    border: '1px solid #c8e6c9',
                    borderRadius: 6,
                    color: '#2e7d32',
                    marginBottom: 16,
                  }}
                >
                  Product Transfer Success
                </div>
              )}
    
              {!isTransferred && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                  {/* Step Card */}
                  {/* <div
                    style={{
                      padding: 20,
                      backgroundColor: '#fff',
                      border: '1px solid #e0e0e0',
                      borderRadius: 6,
                    }}
                  >
                    <div style={{ marginBottom: 8 }}>
                      <h3 style={{ fontWeight: 600, fontSize: 18, margin: 0 }}>Step 2 of 2: Activate Product</h3>
                    </div>
                    <p style={{ fontWeight: 400, fontSize: 14, margin: 0, lineHeight: 1.5 }}>
                      After login to accept the invitation, an activation for the new product enablement is required.
                    </p>
                  </div> */}
    
                  {/* Product Details Card */}
                  <div
                    style={{
                      padding: 20,
                      backgroundColor: '#fff',
                      border: '1px solid #e0e0e0',
                      borderRadius: 6,
                    }}
                  >
                    <div style={{ marginBottom: 16 }}>
                      <h3 style={{ fontWeight: 600, fontSize: 18, margin: '0 0 10px 0' }}>NGC Product Details</h3>
                      <div
                        style={{
                          minHeight: 30,
                          width: '100%',
                          border: '2px solid #e0e0e0',
                          background: '#f9f9f9',
                          color: '#444',
                          lineHeight: '30px',
                          padding: 1,
                          borderRadius: 6,
                          wordBreak: 'break-word',
                        }}
                      >
                        {accountsData && Array.isArray(accountsData.products) && accountsData.products.length > 0
                          ? accountsData.products.map(p => p && p.displayName).filter(Boolean).join(', ')
                          : '—'}
                      </div>
    
                      <h4 style={{ fontWeight: 600, fontSize: 16, margin: '16px 0 8px 0' }}>
                        Included Subscriptions
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'row', gap: 8, flexWrap: 'wrap' }}>
                        {Array.isArray(includedSubscriptions) && includedSubscriptions.length > 0 ? (
                          includedSubscriptions.map((sub, subIndex) => (
                            <span
                              key={`${sub}-${subIndex}`}
                              style={{
                                backgroundColor: '#76b900',
                                color: '#fff',
                                padding: '4px 12px',
                                borderRadius: 12,
                                fontSize: 12,
                                fontWeight: 600,
                              }}
                            >
                              {formatStartCaseSpacedString(sub)}
                            </span>
                          ))
                        ) : (
                          <span style={{ color: '#777', fontSize: 13 }}>No subscriptions</span>
                        )}
                      </div>
                    </div>
                  </div>
    
                  {/* NCA Card */}
                 
                </div>
              )}
            </div>
          </div>
        )}









<div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>





 
                  </div>
{noClaimFlow && (
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
          {/* <div style={{ 
            padding: '24px', 
            marginBottom: '24px',
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '4px'
          }}>
            <h2 style={{ 
              fontFamily: 'NVIDIA', 
              fontWeight: '500', 
              fontSize: '20px',
              color: '#333',
              marginBottom: '12px'
            }}>
              Select NVIDIA Cloud Account
            </h2>
          
          </div> */}

          <div style={{ 
            padding: '24px', 
            marginBottom: '24px',
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '4px'
          }}>
            <h3 style={{ 
              fontFamily: 'NVIDIA', 
              fontWeight: '500', 
              fontSize: '18px',
              color: '#333',
              marginBottom: '16px'
            }}>
              NVIDIA Cloud Account (NCA)
            </h3>
            
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#f8f9fa', 
              border: '1px solid #e9ecef',
              borderRadius: '4px',
              marginBottom: '20px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <FontAwesomeIcon 
                  icon={faInfoCircle} 
                  style={{ color: '#6c757d', height: 18, width: 18, marginRight: '8px' }}
                />
                <span style={{ 
                  fontFamily: 'NVIDIA', 
                  fontWeight: '500', 
                  fontSize: '16px',
                  color: '#495057'
                }}>
                  No existing accounts found
                </span>
              </div>
              <p style={{ 
                fontFamily: 'NVIDIA', 
                fontWeight: '400', 
                fontSize: '14px',
                color: '#6c757d',
                lineHeight: '1.5',
                marginBottom: '16px'
              }}>
                You don't have any existing NVIDIA Cloud Accounts. You can create a new account to activate your product.
              </p>
            </div>

            <div style={{ 
              padding: '32px',
              backgroundColor: 'white',
              border: '1px solid #e0e0e0',
              borderRadius: '4px'
            }}>
              <Button
              //  onClick={handleClickNCA}
              onClick={() => handleClickNCA()}
              className="custom-new-button"
                style={{ padding: '12px 24px', fontSize: '16px' }}
              >
                Create New NCA
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
